import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['day', 'month', 'year', 'hidden'];
  static values = { initial: String };

  connect() {
    if (this.initialValue) {
      const parts = this.initialValue.split('-');
      if (parts.length === 3) {
        this.yearTarget.value = parts[0];
        this.monthTarget.value = String(parseInt(parts[1], 10));
        this.dayTarget.value = String(parseInt(parts[2], 10));
      }
    }
  }

  update() {
    const day = this.dayTarget.value;
    const month = this.monthTarget.value;
    const year = this.yearTarget.value;

    if (day && month && year) {
      const paddedMonth = month.padStart(2, '0');
      const paddedDay = day.padStart(2, '0');
      this.hiddenTarget.value = `${year}-${paddedMonth}-${paddedDay}`;
    } else {
      this.hiddenTarget.value = '';
    }

    // No bubbling change event — avoids triggering the form controller's auto-refetch
  }
}
